import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2620e38a&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Home.vue?vue&type=style&index=1&id=2620e38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620e38a",
  null
  
)

export default component.exports